export default __webpack_public_path__ + "locales/it/EmbeddingPanel.json?hash=9eb7698e8d6513b6f32ea91361078605";